import React, { Component } from 'react';

// Tall ones
import bitchPlate from '../images/bitch_plate.jpg';
import soapBottle from '../images/soap_bottle.jpg';
import ginCup from '../images/gin_cup.jpg';

// Wides ones
import bitchTeacup from '../images/bitch_teacup.jpg';
import openPackage from '../images/open_package.jpg';
import radioBitch from '../images/radio_bitch.jpg';


export class Home extends Component {
  render() {
    return (
      <div className="home-wrapper">
        <div className="home-container">
          <div className="bitchPlate">
            <img src={bitchPlate} alt="bitchPlate" />
          </div>
          <div className="soapBottle">
            <img src={soapBottle} alt="soapBottle" />
          </div>
          <div className="ginCup">
            <img src={ginCup} alt="ginCup" />
          </div>

          <div className="bitchTeacup">
            <img src={bitchTeacup} alt="bitchTeacup" />
          </div>
          <div className="openPackage">
            <img src={openPackage} alt="openPackage" />
          </div>
          <div className="radioBitch">
            <img src={radioBitch} alt="radioBitch" />
          </div>
        </div>
      </div>

    )
  }
}



// WEBPACK FOOTER //
// ./src/home/Home.js